export default __webpack_public_path__ + "static/media/DSC_3736.8f2b820a.jpg";